import React from 'react';

// Shared north-east arrow glyph, with the U+FE0E text-presentation
// selector so mobile browsers render it as a plain glyph rather than a
// colored emoji.
const GLYPH = '\u2197\uFE0E';

interface ArrowIconProps {
  className?: string;
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({ className }) => (
  <span className={className} aria-hidden="true">
    {GLYPH}
  </span>
);
